import { styled, useTheme } from "@mui/material/styles";
import MuiTableHead, { TableHeadProps } from "@mui/material/TableHead";
import { TableRowRoot } from "./TableRowRoot";
import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material";
import { StyledTableCell } from "./StyledTableCell";
import { convertStringToSentenceCase } from "utilz/helpers";

import type {
  GroupedTableCellProps,
  GroupedTableHeaderItem,
} from "./GroupedTable";

type HeaderProps = GroupedTableHeaderItem;

interface CustomTableHeadProps extends TableHeadProps {
  headers: Array<HeaderProps>;
  groupedHeaders?: Array<HeaderProps>;
  headerCellStyles?: SxProps<Theme>;
  cellProps?: GroupedTableCellProps;
}
export const GroupedTableHeader = ({
  headers,
  groupedHeaders,
  headerCellStyles,
  cellProps,
  ...rest
}: CustomTableHeadProps) => {
  const subHeaders = headers.slice(1);

  return (
    <TableHeadStyled {...rest}>
      <TableRowRoot header>
        {groupedHeaders?.map((headCell, index) => (
          <StyledTableCell
            rowSpan={index === 0 ? 2 : 1}
            colSpan={index === 0 ? 1 : headers?.length}
            sx={{
              padding: "6px 16px",
              whiteSpace: "nowrap",
              fontSize: "14px",
              "& .sort-button": {
                visibility: "hidden",
              },
              "&:hover": {
                "& .sort-button": {
                  visibility: "visible",
                },
              },
              borderRight: index === 0 ? "1px solid #FFF" : "none",
              ...cellProps?.[headCell.key]?.sx,
              ...headerCellStyles,
            }}
            key={headCell.name}
            align={headCell.numeric ? "right" : "left"}
            // padding={headCell.disablePadding ? "none" : "normal"}
            // sortDirection={orderBy === headCell.id ? order : false}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: index === 0 ? "flex-start" : "center",
                alignItems: index === 0 ? "flex-start" : "center",
                gap: "8px",
                // color: theme.palette.lightBg.high,
              }}
            >
              {headCell.name ? convertStringToSentenceCase(headCell.name) : ""}
              <HeaderSuffix suffix={headCell.suffix} />
            </Box>
          </StyledTableCell>
        ))}
      </TableRowRoot>
      <TableRowRoot header>
        {/* the first column spans both header rows, so skip it here */}
        {subHeaders.map((headCell, index) => {
          return (
            <StyledTableCell
              colSpan={1}
              sx={{
                padding: "6px 16px",
                whiteSpace: "nowrap",
                fontSize: "14px",
                "& .sort-button": {
                  visibility: "hidden",
                },
                "&:hover": {
                  "& .sort-button": {
                    visibility: "visible",
                  },
                },
                borderRight:
                  index !== subHeaders.length - 1 ? "1px solid #FFF" : "none",
                ...headerCellStyles,
              }}
              key={headCell.name}
              align={headCell.numeric ? "right" : "left"}
              // padding={headCell.disablePadding ? "none" : "normal"}
              // sortDirection={orderBy === headCell.id ? order : false}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "8px",
                  // color: theme.palette.lightBg.high,
                }}
              >
                {headCell.name
                  ? convertStringToSentenceCase(headCell.name)
                  : ""}
                <HeaderSuffix suffix={headCell.suffix} />
                {/* TODO: add sorting */}
              </Box>
            </StyledTableCell>
          );
        })}
      </TableRowRoot>
    </TableHeadStyled>
  );
};
const HeaderSuffix = ({ suffix }: { suffix?: string }) => {
  const theme = useTheme();
  if (!suffix) return null;
  return (
    <Box
      component="span"
      sx={{
        color: theme.palette.lightBg.low,
        fontWeight: theme.typography.fontWeightRegular,
      }}
    >
      {suffix}
    </Box>
  );
};

const TableHeadStyled = styled(MuiTableHead)<TableHeadProps>(({ theme }) => {
  return {
    ...theme.typography.caption,
  };
});
